export const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://supmmo.com/api' 
  : 'https://supmmo.com/api'; 
export const BASE_URL = process.env.NODE_ENV === 'production' 
? 'https://supmmo.com/' 
: 'https://supmmo.com/'; 